import {useTranslation} from "react-i18next";
import {SecondaryButton} from "../Buttons/SecondaryButton";
import NotFoundImagePlaceholder from "../../Assets/images/illustrations/not_found_image_placeholder.svg";
import {useBoundStore} from "../../Store/store";
import {parseStringToDateTimeWithDayjs} from "../../Utils/DateHelper";
import * as React from "react";
import dayjs from "dayjs";
import {Link} from "react-router-dom";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const AdminApplicationCard = (props) => {
    const {
        application,
        onClickButton,
        canApply = false,
        imageOverride = null
    } = props;

    const {t} = useTranslation();

    return (
        <div className={'border border-gray-200 rounded-lg m-2'}>
            <div className={'p-4'}>
                <img src={imageOverride !== null ? imageOverride : (application?.image ?? NotFoundImagePlaceholder)}
                     alt={application.title} className={'w-full h-40 object-contain rounded-lg'}/>

                <table className={'mt-4 border-spacing-4 '}>
                    <tbody>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('general.fields.status')}:</td>
                        <td>
                            <div className={'w-fit flex flex-row gap-2'}>
                                {
                                    application?.status === 'applied' && (
                                        <div
                                            className={'px-2 py-1 bg-gray-300 text-gray-900 rounded-full text-xs opacity-70'}>{t('general.status.applied')}</div>
                                    )
                                }

                                {
                                    application?.status === 'rejected' && (
                                        <div
                                            className={'px-2 py-1 bg-red-300 text-red-900 rounded-full text-xs opacity-70'}>{t('general.status.rejected')}
                                        </div>
                                    )
                                }

                                {
                                    application?.status === 'accepted' && (
                                        <div
                                            className={'px-2 py-1 bg-green-300 text-green-900 rounded-full text-xs opacity-70'}>{t('general.status.accepted')}
                                        </div>
                                    )
                                }

                                {
                                    !! application?.in_progress && (
                                        <div
                                            className={'px-2 py-1 bg-blue-300 text-blue-900 rounded-full text-xs opacity-70'}>{t('general.status.in_progress')}
                                        </div>
                                    )
                                }
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.company')}:</td>
                        <td>
                            {application?.shift?.branch?.company_name ?? `${application?.shift?.branch?.contact_firstname} ${application?.shift?.branch?.contact_firstname}`}
                        </td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.freelancer')}:</td>
                        <td>{application?.freelancer?.first_name} {application?.freelancer?.last_name}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.from')}:</td>
                        <td>{parseStringToDateTimeWithDayjs(application?.shift?.start_time)}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.to')}:</td>
                        <td>{parseStringToDateTimeWithDayjs(application?.shift?.end_time)}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.total_time')}:</td>
                        <td>{dayjs.duration(application?.shift?.total_time, 'minutes').humanize()}</td>
                    </tr>
                    <tr>
                        <td className={'font-bold pr-4'}>{t('shifts.total_break')}:</td>
                        <td>{application?.shift?.break_duration === null ? '-' : dayjs.duration(application?.shift?.break_duration, 'minutes').humanize()}</td>
                    </tr>
                    {application?.shift?.allowed_statuten?.length > 0 && (
                        <tr>
                            <td className={'font-bold pr-4 align-top'}>{t('shifts.possible_statuten')}:</td>
                            <td>
                                <div className="flex flex-wrap gap-1">
                                    {application.shift.allowed_statuten.map(s => (
                                        <span key={s} className="text-xs bg-gray-100 text-gray-800 px-2 py-0.5 rounded">
                                            {t(`statuten.${s}`, s)}
                                        </span>
                                    ))}
                                </div>
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>

                <div className={'mt-4 text-center'}>
                    <Link to={`/admin/applications/${application?.id}`}>
                        <p className={'group text-primary'}>
                            {t('general.actions.more_info')}
                            <FontAwesomeIcon icon={faArrowRight} className={'text-sm transition-all group-hover:ml-4 ml-2 duration-300 text-primary cursor-pointer'}/>
                        </p>
                    </Link>
                </div>
            </div>
        </div>
    )
}